import ObjectFitClass from "../utils/_object-fit";

var $ = jQuery;

export default function ObjectFit() {
  new ObjectFitClass()
}